import { render } from "./web_top.vue?vue&type=template&id=dfa0573e&scoped=true&ts=true"
import script from "./web_top.vue?vue&type=script&lang=ts"
export * from "./web_top.vue?vue&type=script&lang=ts"

import "./web_top.vue?vue&type=style&index=0&id=dfa0573e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfa0573e"]])

export default __exports__